<template>
  <vs-row class="bg-white shadow py-5 px-3 mb-4">
    <vs-col vs-lg="1">
      <b-button
        v-tooltip="'Buscar'"
        variant="primary"
        class="btn-icon rounded-circle p-3"
        size="sm"
        v-on:click="appliFilters()"
      >
        <feather-icon icon="SearchIcon"/>
      </b-button>
    </vs-col>
    <vs-col  :vs-lg="11">
      <input
        v-model="filtros.id.value"
        placeholder="Buscar"
        class="form-control"
        data-cy="search"
        v-on:keypress.enter="appliFilters"
      />
    </vs-col>
  </vs-row>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ListFilter',

  components: {},
  data() {
    return {
      filtros: {
        id: {
          key: 'id',
          type: 'wildcard',
          value: '',
          fields: [
            'id'
          ]
        }
      }
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Emails', ['suppressionsPage', 'suppressionsItemsPerPage']),
    ...mapGetters('Usuario', [
      'hasPermission'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    },
    queryFilters() {
      const query = [];
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const filtrosKey in this.filtros) {
        const filter = this.filtros[filtrosKey];
        const { type } = filter;
        let condicion;
        if (type === 'multi_match') {
          const { fields, value } = filter;
          if (value) {
            condicion = {
              multi_match: {
                query: value,
                fields
              }
            };
          }
        } else
        if (type === 'wildcard') {
          const { value, key } = filter;
          if (value) {
            condicion = {
              wildcard: {
                [`${key}.keyword`]: {
                  value: `*${value}*`
                }
              }
            };
          }
        } else if (type === 'keyword') {
          const { value } = filter;
          if (value) {
            condicion = this.generateTermCondition({ ...filter, value });
          }
        } else {
          const filterValue = Array.isArray(filter.value) ? filter.value : [filter.value];
          if (filterValue.length === 0) {
            // eslint-disable-next-line no-continue
            continue;
          } else if (filterValue.length > 1) {
            condicion = {
              bool: {
                should: filterValue.map(
                  (value) => this.generateTermCondition({ ...filter, value })
                ),
                adjust_pure_negative: true,
                boost: 1.0
              }
            };
          } else {
            condicion = this.generateTermCondition(filter);
          }
        }
        if (condicion) {
          query.push(condicion);
        }
      }
      return {
        bool: {
          filter: query,
          adjust_pure_negative: true,
          boost: 1.0
        }
      };
    }
  },
  watch: {
    suppressionsPage() {
      this.debounceFetchData();
    },
    suppressionsItemsPerPage() {
      this.debounceFetchData();
    }
  },
  methods: {
    ...mapActions('Emails', ['getEmailSuppressedList', 'movePageSuppressed']),
    generateTermCondition({ key, type = 'multi-keyword', value }) {
      let sufix = '';
      if (
        [
          'multi-keyword',
          'keyword'
        ].indexOf(type) >= 0) {
        sufix = '.keyword';
      }
      const filterValue = Array.isArray(value) ? value : [value];
      return {
        term: {
          [`${key}${sufix}`]: {
            value: filterValue[0],
            boost: 1.0
          }
        }
      };
    },
    async fetchData() {
      this.debounceFetchData();
    },
    debounceFetchData: _.debounce(async function debounceFetchData() {
      const query = {
        query: this.queryFilters,
        page: this.suppressionsPage,
        itemPerPage: this.suppressionsItemsPerPage,
      };
      await this.getEmailSuppressedList(query);
    }, 100),
    removeCompany() {
      this.filtros.empresa.value = [];
      this.appliFilters();
    },
    appliFilters() {
      this.movePageSuppressed(1);
      this.debounceFetchData();
    },
    changeFilters() {
      console.log('cambiando a fechas personalizadas');
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>
<style scoped>
.loadData {
  height: 80vh;
}
</style>
